// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import axios from 'axios'
import App from './App'
import VueRouter from 'vue-router'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './style/common.css'
import './style/element.css'
import i18n from './local'


//使用Axios
Vue.prototype.axios = axios
//使用VueRouter
Vue.use(VueRouter)
Vue.use(ElementUI)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n, //将i18n挂载到vue全局使用
  components: { App },
  template: '<App/>'
})

// var a=Math.max(document.getElementById("liuxing").offsetHeight,document.getElementById("okdata").offsetHeight);
// document.getElementById("liuxing").style.height = a + "px";
// document.getElementById("okdata").style.height = a + "px";


// WEBPACK FOOTER //
// ./src/main.js